import React from 'react';

import Link from '../editor/Link'


const BTagsEditor = (props) => {
    return (
        <div>
            {props.children}

            <div className="form-group">
                <label className="col-sm-3 control-label">Nazwa tematu</label>
                <div className="col-sm-9">
                    <input type="text" name="linkName" className="form-control" defaultValue={props.settings.linkName} />
                </div>
            </div>
            <div className="form-group">
                <Link value={props.settings.link} />
            </div>
        </div>
    );
}


export default BTagsEditor;